import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-47" data-mp="3udp26xtznyt6">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-gold-900/20 via-navy-950 to-navy-950 pointer-events-none" data-id="element-48" data-mp="c7tvnlnquuuk" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-49" data-mp="m4ow4a3kv5bh">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-50" data-mp="m340eh5j1gc1">
          <h2 className="text-4xl font-bold text-white mb-12" data-id="element-51" data-mp="14uwtscoid3ka">
            El Próximo Paso Es Tuyo
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 text-left" data-id="element-52" data-mp="zxehccba867j">
            <div className="bg-navy-900/50 border border-white/5 p-8 rounded-2xl opacity-70" data-id="element-53" data-mp="2c56dc9woafm1">
              <h3 className="text-xl font-bold text-slate-400 mb-4" data-id="element-54" data-mp="2h37weuu3mexi">
                Opción A:
              </h3>
              <p className="text-slate-400" data-id="element-55" data-mp="2m2ksm66v0ycr">
                Seguir haciendo lo mismo. Más cursos sueltos, más consejos
                genéricos, más meses sin resultados.
              </p>
            </div>

            <div className="bg-navy-800 border border-gold-500/40 p-8 rounded-2xl box-glow relative" data-id="element-56" data-mp="2v2hfc29ovn56">
              <div className="absolute -top-3 -right-3 w-6 h-6 bg-gold-500 rounded-full animate-pulse" data-id="element-57" data-mp="301as1sh5ja4a" />
              <h3 className="text-xl font-bold text-gold-400 mb-4" data-id="element-58" data-mp="34un2myozxge1">
                Opción B:
              </h3>
              <p className="text-white font-medium" data-id="element-59" data-mp="39rn9vcxl0p6q">
                Obtener el sistema completo hoy. Empezar a ejecutar mañana.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center space-x-4 mb-6" data-id="element-60" data-mp="3itwk01oxugjl">
            <span className="text-slate-500 line-through text-xl" data-id="element-61" data-mp="1jntnvjednft2">$17.99</span>
            <span className="text-5xl font-black text-gold-400 text-glow" data-id="element-62" data-mp="1ep8n9iv7qu43">
              $6.36{' '}
              <span className="text-lg font-medium text-gold-300" data-id="element-63" data-mp="1sgew45kdu43n">USD</span>
            </span>
          </div>
          <p className="text-sm text-slate-400 mb-8" data-id="element-64" data-mp="1npezz2j37q27">
            Precio especial por tiempo limitado
          </p>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full sm:w-auto" data-id="element-65" data-mp="22e1n3qeyhm3z">
            <button className="w-full sm:w-auto px-10 py-6 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-950 font-black text-xl sm:text-2xl rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.5)] hover:shadow-[0_0_50px_rgba(212,175,55,0.7)] transition-all duration-300 flex items-center justify-center space-x-3 group" data-id="element-66" data-mp="2bezk3oqz8td2">
              <span data-id="element-67" data-mp="2vg7bwzroj8s">SÍ, QUIERO EL SISTEMA COMPLETO</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-68" data-mp="2y2o8n8jsb3o" />
            </button>
          </motion.div>

          <p className="mt-6 text-slate-400 max-w-2xl mx-auto" data-id="element-69" data-mp="3pc2kb23ymzvl">
            Accede ahora a "Secretos de Promoción" y empieza a construir el
            negocio de afiliados que llevas meses intentando levantar
          </p>

          <div className="mt-12 max-w-3xl mx-auto" data-id="element-70" data-mp="3fcbmaqg6y2qr">
            <div className="relative w-full overflow-hidden rounded-2xl border border-gold-500/25 bg-navy-900 shadow-[0_20px_60px_rgba(0,0,0,0.45)]" data-id="element-71" data-mp="3kcg6aqgb5flq">
              <div className="relative w-full pt-[56.25%]" data-id="element-72" data-mp="36dzzz0mcxr44">
                <iframe src="https://player.vimeo.com/video/1205946044" title="Secretos de Promoción" className="absolute inset-0 h-full w-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" allowFullScreen data-id="element-73" data-mp="3bbhz5zakoryx" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}